import script from "./ArticleIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleIndex.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleIndex.vue?vue&type=style&index=0&id=7fb85083&lang=css"
import "./ArticleIndex.vue?vue&type=style&index=1&id=7fb85083&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb85083"]])

export default __exports__